
    import { defineComponent } from 'vue';
    import BaseLoader from '@/components/BaseLoader.vue';

    export default defineComponent({
        name      : 'ImageLoaderOverlay',
        components: { BaseLoader },
    });
